import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler,
} from "src/app/shared/services/handle-error.service";
import { RequestCRUD } from "src/app/shared/services/abstract/request-crud.service";
import { ResponseServiceModel } from "src/app/shared/models/response-service.model";
import { Observable, of } from "rxjs";
import { retry } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { EnviromentGlobalService } from "src/app/shared/services/enviroment-global.service";

@Injectable()
export class PreguntaAdicionalEncuestaService
  implements RequestCRUD<any, ResponseServiceModel> {
  private API_URL;
  private handleError: HandleError;
  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.handleError = httpErrorHandler.createHandleError(
      "PreguntaAdicionalEncuesta"
    );
    this.API_URL = enviromentGlobalService.apiUrl;
  }

  get(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/PreguntaAdicionalEncuestaAdministrador/Paginado?PageNumber=${entry.numeroPagina}&PageSize=12`,
        entry
      )
      .pipe(retry(2));
  }

  update(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .put<ResponseServiceModel>(
        `${this.API_URL}/PreguntaAdicionalEncuestaAdministrador/${entry.pregunta_adicional_encuesta_id}`,
        entry
      )
      .pipe(retry(2));
  }

  create(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(
        `${this.API_URL}/PreguntaAdicionalEncuestaAdministrador/Crear`,
        entry
      )
      .pipe(retry(2));
  }

  delete(entry: any): Observable<ResponseServiceModel> {
    // tslint:disable-next-line:max-line-length
    return this.http
      .delete<ResponseServiceModel>(
        `${this.API_URL}/PreguntaAdicionalEncuestaAdministrador/${entry.pregunta_adicional_encuesta_id}`
      )
      .pipe(retry(2));
  }

  getTipoPreguntaEncuesta(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/TipoPreguntaEncuesta`)
      .pipe(retry(2));
  }

  getTipoValor(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(
        `${this.API_URL}/PreguntaTipoValor/ObtenerTipoValorPregunta`
      )
      .pipe(retry(2));
  }

  getCamaraComercio(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/CamaraComercio`)
      .pipe(retry(2));
  }

  getSeccionEncuesta(): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/SeccionEncuesta`)
      .pipe(retry(2));
  }

  createListaValor(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/PreguntaAdicionalEncuestaListaValorAdministrador/crear`, entry)
      .pipe(retry(2));
  }

  updateListaValor(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(`${this.API_URL}/PreguntaAdicionalEncuestaListaValorAdministrador/Actualizar`, entry)
  }

  updatePreguntaFormuladaCondicionBloqueo(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(`${this.API_URL}/PreguntaAdicionalEncuestaAdministrador/ActualizarFormulaCondicionBloqueo`, entry)
  }

  crearPreguntaCondicionada(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/PreguntaAdicionalEncuestaCondicionAdministrador/Crear`, entry)
  }

  updatePreguntaCondicionada(entry: any): Observable<ResponseServiceModel> {
    return this.http
      .put<ResponseServiceModel>(`${this.API_URL}/PreguntaAdicionalEncuestaCondicionAdministrador/Actualizar`, entry)
  }

  createEnlazarPreguntas(entry: any): Observable<ResponseServiceModel> {
    const endPoint = entry.clase_pregunta_id === 2 ?
      "PreguntaAdicionalEncuestaAdministrador" :
      "PreguntaEncuestaAdministrador";
    return this.http
      .post<ResponseServiceModel>(`${this.API_URL}/${endPoint}/EnlazarPreguntas`, entry)
  }

  getModuloEncuestaByAnio(anio: number): Observable<ResponseServiceModel> {
		return this.http.get<ResponseServiceModel>(`${this.API_URL}/ModuloEncuesta/anio/${anio}`).pipe(
			retry(2)
		);
	}

  getSeccionEncuestaByModulo(moduloId: number): Observable<ResponseServiceModel> {
    return this.http
      .get<ResponseServiceModel>(`${this.API_URL}/SeccionEncuesta/modulo/${moduloId}`)
      .pipe(retry(2));
  }
}
